<template>
    <div class="asset--wrapper">
        <div class="asset__img">
            <img :src=imgSrc width="100" height="100"/>
        </div>
        <div class="asset__text">
            <h2 class="asset__header">{{heading}}</h2>
            <p class="paragraph asset__paragraph">
                {{ text }}
            </p>

        </div>
    </div>
</template>

<script>
    export default {
        name: "GridAsset",
        props: {
            imgSrc: String,
            text: String,
            heading: String
        }
    }
</script>

<style scoped lang="scss">
    .asset--wrapper {
        max-width: 400px;
        margin-bottom: 30px;
        padding-right: 28px;
    }

    .asset__img {
        max-width: 118px;
        margin: auto;
        margin-left: 0%;
    }

    .asset__header {
        color: black;
        text-align: left;
        margin-left: 0%;
        margin-top: 30px;
        margin-bottom: 13px;
        letter-spacing: 0.32px;
        font-family: 'Inter UI', sans-serif;
    }

    .asset__paragraph {
        word-wrap: break-word;
        max-width: 377px;
        margin: auto;
        margin-left: 0%;
        text-align: left;
        line-height: 28px;
    }
</style>


// WEBPACK FOOTER //
// src/components/GridAsset.vue